import { useQuery } from "@tanstack/react-query";
import { getEventOrganizerPeople, getInstitutionPeople } from "@/api/organiser-desk";

/**
 * The host's people: followers, their families' states above the floor, and
 * how many came back. Counts only; a state under the floor is not shown.
 */
export function HostPeoplePanel({ kind, id }: { kind: "event_organizer" | "institution"; id: string }) {
  const { data, error } = useQuery({
    queryKey: ["host-people", kind, id],
    queryFn: () => (kind === "event_organizer" ? getEventOrganizerPeople(id) : getInstitutionPeople(id)),
    retry: false,
  });
  const people = data?.data;

  return (
    <section className="bg-white border border-gray-200 rounded-2xl p-5 space-y-2">
      <h3 className="font-semibold text-gray-900">Your people</h3>
      {error && <p className="text-sm text-red-700">{(error as Error).message}</p>}
      {people && (
        <div className="text-sm text-gray-700 space-y-1">
          <p>
            <strong>{people.followerCount}</strong> follow
          </p>
          <p>
            Roots (at least {people.rootsFloor} each):{" "}
            {people.roots.length ? people.roots.map((r) => `${r.label} ${r.count}`).join(" · ") : "none above the floor"}
          </p>
          <p>
            {people.cameBack.cameBack} of {people.cameBack.people12m} who went this year came to more than one event
          </p>
        </div>
      )}
    </section>
  );
}
